// extracted by mini-css-extract-plugin
export default {"svg":"pathAnimation_svg__k5-Sw","ctn":"pathAnimation_ctn__vOXz1","playIcon":"pathAnimation_playIcon__qq-24"};